define(["exports", "./biblio-db", "./utils", "./pubsubhub", "./render-biblio"], function (_exports, _biblioDb, _utils, _pubsubhub, _renderBiblio) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.updateFromNetwork = updateFromNetwork;
  _exports.resolveRef = resolveRef;
  _exports.run = run;
  Object.defineProperty(_exports, "wireReference", {
    enumerable: true,
    get: function get() {
      return _renderBiblio.wireReference;
    }
  });
  Object.defineProperty(_exports, "stringifyReference", {
    enumerable: true,
    get: function get() {
      return _renderBiblio.stringifyReference;
    }
  });
  _exports.name = _exports.biblio = void 0;
  // @ts-check
  // Module core/biblio
  // Pre-processes bibliographic references
  // Configuration:
  //  - localBiblio: override or supplement the official biblio with your own.

  /* jshint jquery: true */
  const biblio = {}; // for backward compatibity

  _exports.biblio = biblio;
  const name = "core/biblio";
  _exports.name = name;
  const bibrefsURL = new URL("https://specref.herokuapp.com/bibrefs?refs=");
  /**
   * Normative references take precedence over informative ones,
   * so any duplicates ones are removed from the informative set.
   */

  function normalizeReferences(conf) {
    const normalizedNormativeRefs = new Set([...conf.normativeReferences].map(key => key.toLowerCase()));
    Array.from(conf.informativeReferences).filter(key => normalizedNormativeRefs.has(key.toLowerCase())).forEach(redundantKey => conf.informativeReferences.delete(redundantKey));
  }

  function getRefKeys(conf) {
    return {
      informativeReferences: Array.from(conf.informativeReferences),
      normativeReferences: Array.from(conf.normativeReferences)
    };
  } // Opportunistically dns-prefetch to bibref server, as we don't know yet
  // if we will actually need to download references yet.


  const link = (0, _utils.createResourceHint)({
    hint: "dns-prefetch",
    href: bibrefsURL.origin
  });
  document.head.appendChild(link);
  let doneResolver;
  const done = new Promise(resolve => {
    doneResolver = resolve;
  });

  async function updateFromNetwork(refs, options = {
    forceUpdate: false
  }) {
    const refsToFetch = [...new Set(refs)].filter(ref => ref.trim()); // Update database if needed, if we are online

    if (!refsToFetch.length || navigator.onLine === false) {
      return null;
    }

    let response;

    try {
      response = await fetch(bibrefsURL.href + refsToFetch.join(","));
    } catch (err) {
      console.error(err);
      return null;
    }

    if (!options.forceUpdate && !response.ok || response.status !== 200) {
      return null;
    }

    const data = await response.json();

    try {
      await _biblioDb.biblioDB.addAll(data);
    } catch (err) {
      console.error(err);
    }

    return data;
  }
  /**
   * @param {string} key
   */


  async function resolveRef(key) {
    const biblio = await done;

    if (!biblio.hasOwnProperty(key)) {
      return null;
    }

    const entry = biblio[key];

    if (entry.aliasOf) {
      return await resolveRef(entry.aliasOf);
    }

    return entry;
  }

  async function run(conf) {
    const finish = () => {
      doneResolver(conf.biblio);
    };

    if (!conf.localBiblio) {
      conf.localBiblio = {};
    }

    if (conf.biblio) {
      let msg = "Overriding `.biblio` in config. Please use ";
      msg += "`.localBiblio` for custom biblio entries.";
      (0, _pubsubhub.pub)("warn", msg);
    }

    conf.biblio = biblio;
    const localAliases = Array.from(Object.keys(conf.localBiblio)).filter(key => conf.localBiblio[key].hasOwnProperty("aliasOf")).map(key => conf.localBiblio[key].aliasOf);
    normalizeReferences(conf);
    const allRefs = getRefKeys(conf);
    const neededRefs = allRefs.normativeReferences.concat(allRefs.informativeReferences) // Filter, as to not go to network for local refs
    .filter(key => !conf.localBiblio.hasOwnProperty(key)) // but include local aliases, in case they refer to external specs
    .concat(localAliases) // remove duplicates
    .reduce((collector, item) => {
      if (collector.indexOf(item) === -1) {
        collector.push(item);
      }

      return collector;
    }, []).sort();
    const idbRefs = []; // See if we have them in IDB

    try {
      await _biblioDb.biblioDB.ready; // can throw

      const promisesToFind = neededRefs.map(async id => ({
        id,
        data: await _biblioDb.biblioDB.find(id)
      }));
      idbRefs.push(...(await Promise.all(promisesToFind)));
    } catch (err) {
      // IndexedDB died, so we need to go to the network for all
      // references
      idbRefs.push(...neededRefs.map(id => ({
        id,
        data: null
      })));
      console.warn(err);
    }

    const split = {
      hasData: [],
      noData: []
    };
    idbRefs.forEach(ref => {
      (ref.data ? split.hasData : split.noData).push(ref);
    });
    split.hasData.forEach(ref => {
      biblio[ref.id] = ref.data;
    });
    const externalRefs = split.noData.map(item => item.id);

    if (externalRefs.length) {
      // Going to the network for refs we don't have
      const data = await updateFromNetwork(externalRefs, {
        forceUpdate: true
      });
      Object.assign(biblio, data);
    }

    Object.assign(biblio, conf.localBiblio);
    finish();
  }
});
//# sourceMappingURL=biblio.js.map